import React from "react";
import Drawer from "rc-drawer";
import "rc-drawer/assets/index.css";
import { useBreakpoint } from "gatsby-plugin-breakpoints";
import { renderForMobile } from "utils/renderForMobile";

const CommonDrawer = ({
  children,
  visible,
  placement,
  width,
  height,
  ...rest
}) => {
  const breakpoints = useBreakpoint();
  const drawerWidth =
    (renderForMobile(breakpoints) && width) ||
    placement === "top" ||
    placement === "bottom" ||
    (placement === "right" && width !== "100%")
      ? width
      : "383px";
  const drawerHeight =
    (renderForMobile(breakpoints) && height) ||
    ((placement === "right" || placement === "left") && "100%");

  return (
    <Drawer
      placement={placement}
      open={visible}
      width={drawerWidth}
      height={drawerHeight}
      level={null}
      {...rest}>
      {children}
    </Drawer>
  );
};

CommonDrawer.defaultProps = {
  visible: false,
  placement: "right",
  handler: false,
  width: "100%",
  height: "100%",
};

export default CommonDrawer;
